module.exports = __webpack_public_path__ + "static/media/Narrowed Joint Space.a9a35053.png";